// Backend sends is_open (1/0) on providers with working days & shifts, meaning
// "open right now". Older payloads only have is_closed, so fall back to it.
export const isClosedNow = (item) => {
  if (!item) return false;
  if (item.is_open !== undefined && item.is_open !== null) {
    return Number(item.is_open) === 0;
  }
  return !!item.is_closed;
};
